import React, { useMemo } from "react";
import { getFormattedNumber } from "../utils/textUtils";

const ProductionSummary = ({ resPacket }) => {

  const total = useMemo(() => {
    return resPacket?.reduce((acc, a) => {
      return {
        recQty: acc.recQty + parseFloat(a.batchItemsList[0]?.recQuantity),
        Qty: acc.Qty + parseFloat(a.batchItemsList[0]?.quantity)
      }
    }, { recQty: 0, Qty: 0})
  }, [resPacket])


  return resPacket?.length > 0 ? (
    <div className="customTable" id="scroll">
      <table className="customTable w-100">
        <thead className="fixed-thead">
          <tr>
            <td>SNO.</td>
            <td>BATCH NO.</td>
            <td>BATCH</td>
            <td>MANUFACTURING DATE</td>
            <td>EXPIRY DATE</td>
            <td>ITEM </td>
            <td>RECV QTY</td>
            <td>QTY</td>
            <td>DIFF</td>
            <td>QTY TITLE</td>
          </tr>
        </thead>
        <tbody className="body-scroll-custom">
          {resPacket.map((a, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{a.batchItemsList && a.batchItemsList[0]?.batchName}</td>
              <td>{a.batchItemsList && a.batchItemsList[0]?.batchNo}</td>
              <td>{a.productionMfgDate}</td>
              <td>{a.expiredDate}</td>
              <td>{a.batchItemsList && a.batchItemsList[0]?.itemTitle}</td>
              <td>{parseFloat(a.batchItemsList[0]?.recQuantity).toFixed(2)}</td>
              <td>
                {a.batchItemsList &&
                  getFormattedNumber(a.batchItemsList[0]?.quantity)}
              </td>
              <td>{Math.abs(a.batchItemsList[0]?.recQuantity - (a.batchItemsList[0]?.quantity)).toFixed(3)}</td>
              <td>
                {a.batchItemsList[0]?.recQuantity && a.batchItemsList[0]?.quantityUnitTitle}
              </td>
            </tr>
          ))}
          
          <tr className="total-row" ><td className="font-weight-bold">Total</td><td></td><td></td><td></td><td></td><td></td><td className="font-weight-bold">{parseFloat(total.recQty).toFixed(2)}</td><td>{parseFloat(total.Qty).toFixed(2)}</td><td>{Math.abs(total.recQty-total.Qty).toFixed(2)}</td><td></td></tr>
        </tbody>
      </table>
    </div>
  ) : (
    <>No Records Found</>
  );
};

export default ProductionSummary;
